import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, message, Spin } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import { useMutation } from '@apollo/client';
import './style.less';
import RoleForm from './RoleForm';
import { ADD_ROLE, GET_ROLES } from '../../../gql/roles';
import { getScopesFromInput } from '../../../utils/scopes';

const AddRole = () => {
  const [addRole, { loading: mutationLoading }] = useMutation(ADD_ROLE, {
    refetchQueries: [{ query: GET_ROLES, variables: { state: 'ALL' } }],
    onCompleted: ({ addRole }) => {
      message.success(`${addRole.name} successfully added`);
    },
    onError: (err) => {
      console.log(err);
    },
  });
  return (
    <PageContainer
      header={{
        title: 'Add Role',
        breadcrumb: (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/system-setting/roles">Roles</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Add Role</Breadcrumb.Item>
          </Breadcrumb>
        ),
      }}
    >
      <Spin spinning={mutationLoading} tip="Adding...">
        <RoleForm
          onFinish={(input) => {
            const scopes = getScopesFromInput(input);
            addRole({
              variables: {
                addRoleInput: {
                  name: input.name,
                  description: input.description,
                  isDefaultRoleForNewUser: input.isDefaultRoleForNewUser,
                  reportControlType: input.reportControlType,
                  scopes,
                },
              },
            });
          }}
        />
      </Spin>
    </PageContainer>
  );
};

export default AddRole;
